import {GridColDef, GridRenderCellParams} from '@mui/x-data-grid';
import {t} from 'i18next';
import ArrButton from '../../common/arr-button/ArrButton';
import {redactionStatus} from '../../../shared/constants';
import {IRedactionHistoryItem} from '../../../api/types/redactions.type';
import CellWrapper from '../../common/arr-data-grid-pro/filter-components/cell-wrapper/CellWrapper';

interface GetBatchRedactionGridColumnsProps {
  handleClickActions?: (data: IRedactionHistoryItem) => void;
  handleGenerateReport?: (data: IRedactionHistoryItem) => void;
}

export const getProjectFieldListGridColumns = (
  props: GetBatchRedactionGridColumnsProps
): GridColDef[] => {
  return [
    {
      field: 'batchRedactionID',
      headerName: t('batchRedactions.historyGrid.batchId'),
      maxWidth: 120,
      flex: 1,
      headerClassName: 'no-separator',
      cellClassName: 'no-separator',
    },
    {
      field: 'batchRedactionLabel',
      headerName: t('batchRedactions.historyGrid.savedSearch'),
      maxWidth: 240,
      flex: 1,
      headerClassName: 'typo-text label2_size',
    },
    {
      field: 'redactionLabel',
      headerName: t('batchRedactions.historyGrid.readctiontag'),
      minWidth: 200,
      flex: 1,
      headerClassName: 'typo-text label2_size',
    },
    {
      field: 'constructDocProgress',
      sortable: false,
      headerName: t('batchRedactions.historyGrid.docs'),
      flex: 1,
      headerClassName: 'typo-text label2_size',
    },

    {
      field: 'constructStatus',
      sortable: false,
      headerName: t('batchRedactions.historyGrid.status'),
      minWidth: 300,
      flex: 1,
      headerClassName: 'typo-text label2_size',
      renderCell: (params) => {
        const status = params.row.status;
        const stripHtml = (html: string): string => {
          if (!html) return '';
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.body.textContent?.replaceAll(/\s+/g, ' ').trim() ?? '';
        };
        const parseConstructStatus = stripHtml(params.row.constructStatus);
        let statusTextColor = '';
        if (status === redactionStatus.complete) {
          statusTextColor = 'complete-status-color';
        } else if (status === redactionStatus.failed) {
          statusTextColor = 'failed-status-color';
        }
        return (
          <CellWrapper
            toolTipContent={parseConstructStatus}
            cellParams={params}
            dataTestId={`tooltip-batch-redation-history-column-construct-status-${params.id}`}
          >
            <span
              className={statusTextColor}
              // title={parseConstructStatus}
              data-testid={`batch-redation-history-column-construct-status-${params.id}`}
            >
              {parseConstructStatus}
            </span>
          </CellWrapper>
        );
      },
    },
    {
      field: 'report',
      sortable: false,
      headerName: t('batchRedactions.historyGrid.report'),
      flex: 1,
      headerClassName: 'typo-text label2_size',
      cellClassName: 'item-align-center',
      renderCell: (params: GridRenderCellParams) => {
        const {constructReportLink, status} = params.row;
        if (
          constructReportLink &&
          (status === redactionStatus.complete ||
            status === redactionStatus.rollback)
        ) {
          return (
            <ArrButton
              dataTestId={`redaction-report-button-${params.id}`}
              variant="secondary"
              size="xs"
              onClick={() => props.handleGenerateReport?.(params.row)}
            >
              {t('batchRedactions.historyGrid.generateReport')}
            </ArrButton>
          );
        }

        return null;
      },
    },

    {
      field: 'action',
      sortable: false,
      headerName: 'Actions',
      flex: 1,
      headerClassName: 'typo-text label2_size no-separator',
      cellClassName: 'item-align-center no-separator',
      renderCell: (params: GridRenderCellParams) => {
        const {status, constructAction, rolledBack, isCancelled} = params.row;
        let actionLabel = '';
        if (
          status === redactionStatus.complete &&
          constructAction === t('batchRedactions.historyGrid.rollback')
        ) {
          actionLabel = t('batchRedactions.historyGrid.rollback');
        } else if (status === redactionStatus.falied) {
          actionLabel = rolledBack
            ? t('batchRedactions.historyGrid.rollback')
            : '';
        } else if (status === redactionStatus.preprocessing && !isCancelled) {
          actionLabel = t('batchRedactions.historyGrid.cancelRollback');
        }

        return actionLabel ? (
          <ArrButton
            dataTestId={`redaction-action-button-${params.id}`}
            variant="secondary"
            size="xs"
            onClick={() =>
              params.row.batchRedactionID &&
              props.handleClickActions?.(params.row)
            }
          >
            {actionLabel}
          </ArrButton>
        ) : null;
      },
    },
  ];
};
